export default __webpack_public_path__ + "static/media/Catering.39925b02.svg";